module.exports = __webpack_public_path__ + "static/media/prev.0bf03f4b.svg";